/**
 * App instalada (2026-10-07):
 *  - número en el ícono = avisos sin leer (Android, escritorio e iPhone 16.4+);
 *  - si estuvo en segundo plano más de 15 minutos, al volver se recarga la
 *    pantalla: abrir la app y ver datos de hace una hora confunde.
 */
import { rec_api as api, rec_hC as estadoAvisos } from "../../runtime/index.jsx";

const CADA_MS = 120_000;
const RECARGAR_TRAS_MS = 15 * 60_000;
let iniciado = false;

function instalada() {
  return window.matchMedia?.(`(display-mode: standalone)`).matches || window.navigator.standalone === true;
}

async function actualizarInsignia() {
  if (!(`setAppBadge` in navigator)) return;
  try {
    const { noLeidas } = await api(`/notificaciones/conteo`, { sinCache: true });
    if (noLeidas > 0) await navigator.setAppBadge(noLeidas);
    else await navigator.clearAppBadge();
  } catch {}
}

/** Cuenta al backend cómo se usa este dispositivo (Usuarios → Dispositivos y sesiones). */
async function informarEstado() {
  try {
    const avisos = (await estadoAvisos()) === `activo`;
    await api(`/dispositivos/yo/estado`, { method: `POST`, body: JSON.stringify({ modo: instalada() ? `APP` : `NAVEGADOR`, avisos }) });
  } catch {}
}

export function iniciarAppInstalada() {
  if (iniciado) return;
  iniciado = true;
  actualizarInsignia();
  informarEstado();
  setInterval(() => document.visibilityState === `visible` && actualizarInsignia(), CADA_MS);
  let ocultaDesde = null;
  document.addEventListener(`visibilitychange`, () => {
    if (document.visibilityState === `hidden`) {
      ocultaDesde = Date.now();
      return;
    }
    // No en Inspecciones ni en el gestor: puede haber un acta o un mensaje a medio escribir.
    const enCurso = /^\/(inspecciones|gestor)/.test(window.location.pathname);
    if (instalada() && !enCurso && ocultaDesde && Date.now() - ocultaDesde > RECARGAR_TRAS_MS) {
      window.location.reload();
      return;
    }
    ocultaDesde = null;
    actualizarInsignia();
    informarEstado();
  });
}

export function limpiarInsignia() {
  try { navigator.clearAppBadge?.(); } catch {}
}
